import React from "react";
import { toast } from "sonner";
import type { GoalId, OnboardingAnswers } from "../../../types/onboarding";
import { goalOptions, MAX_GOALS } from "../../../data/onboarding";
import { OptionCard } from "../OptionCard";
import { StepHeading } from "../StepHeading";
interface GoalsStepProps {
  answers: OnboardingAnswers;
  update: (p: Partial<OnboardingAnswers>) => void;
  targetName: string;
}
export function GoalsStep({
  answers,
  update,
  targetName
}: GoalsStepProps) {
  const full = answers.goals.length >= MAX_GOALS;
  const toggle = (id: GoalId) => {
    if (answers.goals.includes(id)) {
      update({
        goals: answers.goals.filter(g => g !== id)
      });
      return;
    }
    if (full) {
      toast("Up to three reasons", {
        description: "Unselect one to swap it."
      });
      return;
    }
    update({
      goals: [...answers.goals, id]
    });
  };
  return <div data-id="element-958" data-mp="2w6bhksnxy5i6">
      <StepHeading title={`Why are you learning ${targetName}?`} description="Pick up to three. It shapes the example sentences, topics and which skills we lean on." data-id="element-959" data-mp="2r9l0c20eh3v6" />
      <div className="mb-3 flex items-center justify-between text-sm" data-id="element-960" data-mp="35oueqst3d83w">
        <span className="font-semibold text-ink-2" aria-live="polite" data-id="element-961" data-mp="3amvzrja2vhi0">
          {answers.goals.length} of {MAX_GOALS} picked
        </span>
      </div>
      <ul className="grid gap-3 sm:grid-cols-2" data-id="element-962" data-mp="31keeb728ysw2">
        {goalOptions.map(g => <li key={g.id} data-id="element-963" data-mp="3paqut6bk5xy9">
            <OptionCard selected={answers.goals.includes(g.id)} muted={full} onClick={() => toggle(g.id)} icon={g.icon} title={g.label} description={g.hint} data-id="element-964" data-mp="3pbjs7gomnb3q" />
          </li>)}
      </ul>
    </div>;
}